import { ReactNode } from 'react'
import { FormValue } from '../../../api/globalTypes'

export type ModuleType = 'project' | 'property'

export interface QuickViewModalProps {
    isOpen: boolean
    quickViewModal: {
        data: ProjectQuickViewData | PropertyQuickViewData
        appModule: ModuleType
    }
}

interface AgentQuickViewData {
    firstName: string
    lastName: string
}

interface MainPhotoQuickViewData {
    id: number
    updated: string
}

export interface ProjectQuickViewData {
    id: number
    internalAppId: string
    agent?: AgentQuickViewData[]
    projectStatus?: FormValue
    projectTitle?: FormValue
    city?: FormValue
    country?: FormValue
    widerArea?: FormValue
    quarter?: FormValue
    street?: string
    streetNumber?: string
    mainPhoto?: MainPhotoQuickViewData
    projectEndDate?: string
    translations?: Record<string, { projectTitle?: string }>
}

export interface PropertyQuickViewData {
    id: number
    internalAppId: string
    city?: FormValue
    country?: FormValue
    widerArea?: FormValue
    quarter?: FormValue
    street?: string
    streetNumber?: string
    price?: number
    area?: number
    floorNo?: number | string
    floorsTotalNo?: number | string
    mainPhoto?: MainPhotoQuickViewData
    propertySubType?: FormValue
    propertyService?: FormValue
    propertyCondition?: FormValue[]
    propertyDescriptions?: FormValue[]
    propertyRoomsNo?: FormValue
    propertyTransaction?: {
        propertyLandRegistryStatus?: FormValue
    }
    translations?: Record<string, { propertyTitle?: string }>
}

export interface QuickViewModalBodyData {
    id: string
    label: string
    value: ReactNode
}

export function isPropertyData(data: ProjectQuickViewData | PropertyQuickViewData): data is PropertyQuickViewData {
    return 'propertyCondition' in data || 'propertyDescriptions' in data || 'propertyTransaction' in data
}
